// @ts-check
import { z } from 'zod';

const PreviewKey = z.object({
  preview_key: z.string(),
});

export default PreviewKey;

/** @typedef {z.infer<typeof PreviewKey>} TPreviewKey */
